<template>
  <div class="company-fill">
    <h3>企业信息补充</h3>
    <div class="form-list">
      <el-form :model="ruleForm" ref="ruleForm" label-width="330px" class="demo-ruleForm">
        <el-col :span="12">
          <el-form-item label="企业名称">
            <el-input v-model="basicInfo.companyName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码">
            <el-input v-model="basicInfo.licenseNum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址">
            <el-input v-model="basicInfo.companyAddress" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册资金">
            <el-input v-model="basicInfo.registeredCapital" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="经营范围">
            <el-input type="textarea" autosize v-model="basicInfo.scope" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业人数">
            <el-input v-model="ruleForm.t1" type="number" placeholder="请输入企业人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本科以上学历人数">
            <el-input v-model="ruleForm.t2" type="number" placeholder="请输入本科以上学历人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年营业额">
            <el-input v-model="ruleForm.t6" type="number" placeholder="请输入年营业额"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="研发费用">
            <el-input v-model="ruleForm.t7" type="number" placeholder="请输入研发费用"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称">
            <el-input v-model="ruleForm.t8" placeholder="请输入产品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发明专利数">
            <el-input v-model="ruleForm.t3" type="number" placeholder="请输入发明专利数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="新型发明专利数">
            <el-input v-model="ruleForm.t4" type="number" placeholder="请输入新型发明专利数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="软件著作权数">
            <el-input v-model="ruleForm.t5" type="number" placeholder="请输入软件著作权数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="国家高新技术企业">
            <el-radio-group v-model="ruleForm.t9">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="自治区科技型中小企业认定">
            <el-radio-group v-model="ruleForm.t10">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="市级科技小巨人认定">
            <el-radio-group v-model="ruleForm.t11">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="市级科技型小微企业认定">
            <el-radio-group v-model="ruleForm.t12">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通过IS09000质量体系认证">
            <el-radio-group v-model="ruleForm.t13">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通过IS014000质量体系认证">
            <el-radio-group v-model="ruleForm.t14">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通过OHSAS18000职业健康安全体系认证">
            <el-radio-group v-model="ruleForm.t15">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCompany, getCompanySupplement, saveCompanySupplement } from "@/api/account";
export default {
  name: 'companyFill',
  data(){
    return{
      ruleForm: {
        t1: '',
        t2: '',
        t3: '',
        t4: '',
        t5: '',
        t6: '',
        t7: '',
        t8: '',
        t9: false,
        t10: false,
        t11: false,
        t12: false,
        t13: false,
        t14: false,
        t15: false,
      },
      basicInfo: {
      }
    }
  },
  mounted () {
    getCompany().then((res) => {
      if (res.data.code == 200) {
        this.basicInfo = res.data.result;
      }
    })
    this.getDetails()
  },
  methods:{
    getDetails(){
      getCompanySupplement().then(res=>{
        console.log(res, 88888)
        if (res.data.code == 200) {
          if(res.data.result){
            this.ruleForm = {... res.data.result}
          }
        }
      })
    },
    onSubmit() {
      let params = {
        ...this.ruleForm,
        t1: Number(this.ruleForm.t1),
        t2: Number(this.ruleForm.t2),
        t3: Number(this.ruleForm.t3),
        t4: Number(this.ruleForm.t4),
        t5: Number(this.ruleForm.t5),
        t6: Number(this.ruleForm.t6),
        t7: Number(this.ruleForm.t7)
      }
      console.log(params, 99999)
      saveCompanySupplement(params).then(res=>{
        console.log(res, 88888)
        if (res.data.code == 200) {
          this.$message.success("保存成功");
          this.getDetails()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-fill{
  h3{
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin: 0;
    padding-left: 10px;
    background-color: #f4f4f4;
  }
  .form-list{
    margin-top: 20px;
  }
}
</style>